var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-swiper"},[_c('swiper',{ref:"bg-swiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_c('div',{staticClass:"bg-swiper__slide re"})]),_vm._v(" "),_c('swiper-slide',[_c('div',{staticClass:"bg-swiper__slide it"})]),_vm._v(" "),_c('swiper-slide',[_c('div',{staticClass:"bg-swiper__slide ls"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f46f01e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swiper.vue
// module id = 26
// module chunks = 0